import { WINDOW } from './types.js';

function getLocationHref() {
  try {
    return WINDOW.document?.location.href ?? "";
  } catch {
    return "";
  }
}

export { getLocationHref };
//# sourceMappingURL=getLocationHref.js.map
